var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSierraLeone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.7561 26.9564C39.5601 24.7898 40.0001 22.4464 40.0001 19.9999C40.0001 17.5535 39.5601 15.2101 38.7561 13.0435L20 11.3043L1.24403 13.0435C0.440046 15.2101 4.57764e-05 17.5535 4.57764e-05 19.9999C4.57764e-05 22.4464 0.440046 24.7898 1.24403 26.9564L20 28.6956L38.7561 26.9564Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 39.9999C28.5993 39.9999 35.9302 34.5724 38.756 26.9564H1.24396C4.06989 34.5724 11.4007 39.9999 20 39.9999Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 -3.05176e-05C11.4007 -3.05176e-05 4.06989 5.42747 1.24396 13.0435H38.7561C35.9302 5.42747 28.5993 -3.05176e-05 20 -3.05176e-05Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSierraLeone);
export default __webpack_public_path__ + "static/media/sierra_leone.503e0405da0d20496fd7b008a69bd5ad.svg";
export { ForwardRef as ReactComponent };